import { render, staticRenderFns } from "./GroupTitle.vue?vue&type=template&id=4c9a1f8b&scoped=true"
var script = {}
import style0 from "./GroupTitle.vue?vue&type=style&index=0&id=4c9a1f8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a1f8b",
  null
  
)

export default component.exports